// extracted by mini-css-extract-plugin
module.exports = {"icon":"ChapterNavigationButton__icon","svg":"ChapterNavigationButton__svg","mirror":"ChapterNavigationButton__mirror","iconWrapper":"ChapterNavigationButton__iconWrapper"};
    if(module.hot) {
      // 1790535732586
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  